import { MenuItem, TextField } from '@mui/material';

import { ANALYTICS_DATE_RANGE_OPTIONS, isAnalyticsDateRange, type AnalyticsDateRange } from './analyticsDateRange';

export type PeriodSelectProps = {
  value: AnalyticsDateRange;
  onChange: (value: AnalyticsDateRange) => void;
};

export const PeriodSelect = ({ value, onChange }: PeriodSelectProps) => {
  return (
    <TextField
      select
      size="small"
      label="Date range"
      value={value}
      onChange={event => {
        const nextValue = event.target.value;
        if (isAnalyticsDateRange(nextValue)) onChange(nextValue);
      }}
      sx={{ minWidth: 200 }}
    >
      {ANALYTICS_DATE_RANGE_OPTIONS.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
